// extracted by mini-css-extract-plugin
export default {"container":"beta-banner_container__UzYH5","banner":"beta-banner_banner__r9cLi","color_dimmer":"beta-banner_color_dimmer__qX6AP","breathe":"beta-banner_breathe__-pFfi"};